exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-options{display:flex;margin-bottom:15px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/FormOptions/FormOptions.less
 ** module id = 1063
 ** module chunks = 0
 **/